import React from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Check, Sparkles, Star, Tag } from "lucide-react";

export default function Pricing() {
  const { t, user } = useApp();
  const navigate = useNavigate();
  const start = () => navigate(user ? "/upload" : "/login");

  return (
    <div className="mx-auto max-w-5xl px-6 py-16">
      <div className="text-center mb-14 rise-in">
        <h1 className="font-serif text-4xl sm:text-5xl font-bold text-amber-50">{t.pricing.title}</h1>
        <p className="mt-4 text-slate-300 max-w-xl mx-auto">{t.pricing.subtitle}</p>
      </div>

      <div className="grid gap-8 md:grid-cols-2 items-stretch">
        {/* Free */}
        <div className="glass rounded-3xl p-8 flex flex-col" data-testid="plan-free">
          <h3 className="font-serif text-xl text-purple-200">{t.pricing.free}</h3>
          <div className="mt-4 font-serif text-4xl text-amber-100">{t.pricing.freePrice}</div>
          <ul className="mt-7 space-y-3 flex-1">
            {t.pricing.freeFeatures.map((f, i) => (
              <li key={i} className="flex items-center gap-3 text-sm text-slate-300">
                <Check size={16} className="text-emerald-400" /> {f}
              </li>
            ))}
          </ul>
          <button onClick={start} data-testid="plan-free-cta" className="btn-ghost-gold rounded-full py-3 mt-8">
            {t.pricing.freeCta}
          </button>
        </div>

        {/* Paid */}
        <div className="relative glass-strong rounded-3xl p-8 flex flex-col border-amber-500/40 gold-glow" data-testid="plan-paid">
          <span className="absolute -top-3 left-1/2 -translate-x-1/2 btn-gold rounded-full px-4 py-1 text-xs flex items-center gap-1">
            <Star size={12} /> {t.pricing.popular}
          </span>
          <h3 className="font-serif text-xl text-gradient-gold">{t.pricing.paid}</h3>
          <div className="mt-4 flex items-baseline gap-2">
            <span className="font-serif text-4xl text-amber-100">₹51</span>
            <span className="text-sm text-slate-500">/ $0.99</span>
          </div>
          <ul className="mt-7 space-y-3 flex-1">
            {t.pricing.paidFeatures.map((f, i) => (
              <li key={i} className="flex items-center gap-3 text-sm text-slate-200">
                <Check size={16} className="text-amber-400" /> {f}
              </li>
            ))}
          </ul>
          <button onClick={start} data-testid="plan-paid-cta" className="btn-gold rounded-full py-3 mt-8 flex items-center justify-center gap-2">
            <Sparkles size={18} /> {t.pricing.paidCta}
          </button>
          <p className="mt-4 text-xs text-slate-500 text-center">{t.pricing.note}</p>
          <p className="mt-1 text-xs text-amber-300/70 text-center flex items-center justify-center gap-1.5">
            <Tag size={12} /> {t.pricing.couponHint}
          </p>
        </div>
      </div>
    </div>
  );
}
